(function () {
  // Self-guard: the <script> tag is printed per section instance, but the
  // global listeners and one-time setup must only run once. Subsequent
  // executions simply (re)initialise any instances not yet wired up.
  if (window.__tileGridSetup) {
    if (window.__tileGridInitAll) window.__tileGridInitAll();
    return;
  }
  window.__tileGridSetup = true;

  var instances = [];

  function initInstance(outer) {
    if (outer.dataset.tileGridReady === 'true') return;

    var track = outer.querySelector('.tile-track');
    if (!track) return;

    var btnPrev = outer.querySelector('.tile-arrow--prev');
    var btnNext = outer.querySelector('.tile-arrow--next');

    function setTrackWidth() {
      track.style.setProperty('--track-w', track.clientWidth + 'px');
    }

    function scrollAmount() {
      var card = track.querySelector('.tile-card');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).gap) || 20;
      return card.offsetWidth + gap;
    }

    function update() {
      var maxScroll   = track.scrollWidth - track.clientWidth;
      var hasOverflow = maxScroll > 2;
      var atStart     = track.scrollLeft <= 2;
      var atEnd       = track.scrollLeft >= maxScroll - 2;

      if (btnPrev) btnPrev.classList.toggle('is-visible', hasOverflow && !atStart);
      if (btnNext) btnNext.classList.toggle('is-visible', hasOverflow && !atEnd);

      outer.classList.toggle('has-overflow', hasOverflow);
      outer.classList.toggle('at-end', atEnd);
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { update(); ticking = false; });
    }, { passive: true });

    if (btnPrev) btnPrev.addEventListener('click', function () {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });
    if (btnNext) btnNext.addEventListener('click', function () {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });

    setTrackWidth();
    update();
    requestAnimationFrame(function () { setTrackWidth(); update(); });

    instances.push({ setTrackWidth: setTrackWidth, update: update });
    outer.dataset.tileGridReady = 'true';
  }

  function initAll() {
    var nodes = document.querySelectorAll('.tile-track-outer');
    for (var i = 0; i < nodes.length; i++) initInstance(nodes[i]);
  }
  window.__tileGridInitAll = initAll;

  // Debounced resize (the original fired on every resize event).
  var resizeRAF;
  window.addEventListener('resize', function () {
    cancelAnimationFrame(resizeRAF);
    resizeRAF = requestAnimationFrame(function () {
      for (var i = 0; i < instances.length; i++) {
        instances[i].setTrackWidth();
        instances[i].update();
      }
    });
  });

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  // Theme editor support.
  document.addEventListener('shopify:section:load', initAll);
})();
